import { CATEGORIES_STORAGE_KEY, DEFAULT_CATEGORIES, BOOKMARKS_COUNT_KEY } from "@/Groups/Polymarket/private/constants/config";

//Загрузка категорий из localStorage или дефолтных
export const getInitialCategories = () => {
  const stored = localStorage.getItem(CATEGORIES_STORAGE_KEY);
  if (stored) return JSON.parse(stored);
  localStorage.setItem(CATEGORIES_STORAGE_KEY, JSON.stringify(DEFAULT_CATEGORIES));
  return DEFAULT_CATEGORIES;
};

//Сохранение категорий в localStorage
export const saveCategories = (categories) => {
  localStorage.setItem(CATEGORIES_STORAGE_KEY, JSON.stringify(categories));
};

//Получение из localStorage кол-во последних запомненных избранных
export const getInitialBookmarksCount = () => {
  try {
    const saved = localStorage.getItem(BOOKMARKS_COUNT_KEY);
    return saved ? parseInt(saved, 10) : 0;
  } catch {
    return 0;
  }
};